<!-- keyboardPress: Set custom functionality on keyboard press (i.e: prevent popup clonsing when enter is pressed)" -->
<!-- (keypress)="keyboardPress($event) | (keydown)="keyboardPress($event) | (keyup)="keyboardPress($event) -->
<form [formGroup]="formControlGroup" (keypress)="keyboardPress($event)" (keyup)="keyboardUp($event)">

    <div class="global-container">

        <!-- Information text -->
        <div class="information_text">
            {{languageService.Strings.popups.title_setFileName}}
        </div>

        <!-- Patient ID input -->
        <div class="input_box">
            <mat-form-field class="input-text" appearance="fill">
                <mat-label>
                    {{languageService.Strings.popups.input_box_label_fileName}}
                </mat-label>

                <input type="text" maxlength="maxLength"  matInput [formControl]="stringFormControl_proposedFileName" [errorStateMatcher]="matcher" 
                    required autocomplete="off">

                <mat-error *ngIf="stringFormControl_proposedFileName.hasError('required')">
                    {{languageService.Strings.errors.error_required}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControl_proposedFileName.hasError('maxlength')">
                    {{languageService.Strings.errors.error_maxLength}} {{stringFormControl_proposedFileName.value.length}} / {{maxLength}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControl_proposedFileName.hasError('specialCharactersValidationError')">
                    {{languageService.Strings.errors.error_specialCharacters}}
                </mat-error>
            
                <mat-error *ngIf="stringFormControl_proposedFileName.hasError('spacesInStringValidationError')">
                    {{languageService.Strings.errors.error_spacesInString}}
                </mat-error>
            </mat-form-field>
        </div>  
        
        <!-- Actions -->
        <div class="base_buttons_container">
            <!-- Exit button --> 
            <button mat-raised-button 
                    color="primary" 
                    class="base_buttons" 
                    (click)="cancelButtonClicked()" 
                    style="width: 47%;">
                {{languageService.Strings.buttons.button_cancel}}
            </button>  
            <!-- Save button -->        
            <button mat-raised-button 
                    color="primary" 
                    class="base_buttons" 
                    (click)="acceptButtonClicked()" 
                    style="width: 47%;" 
                    [disabled]="!formControlGroup.valid"> 
                {{languageService.Strings.buttons.button_accept}}
            </button>   
        </div>
    

    </div>

</form>